export const isFeatureEnabled = (feature) => {
  const { REACT_APP_FeaturesEnabled: FeaturesEnabled } = process.env;
  if (FeaturesEnabled) {
    const features = FeaturesEnabled.split(",");

    const result = features.find((obj) => obj.trim() === feature);

    return !!result;
  }

  return false;
};
